<template>
    <st-modal
        ref='st-add-tax-category-modal'
        hideable
        hide-footer
        hide-header-delimiter
        hide-footer-delimiter
        no-close-on-backdrop
        no-close-on-esc
        size="md"
        :hideHeaderClose="loading"
        :title="$t('TAX_CATEGORY.FORM.ADD_TITLE')"
    >
        <template #body>
            <tax-category-form
                @cancel="hide"
                @submit="submit"
            >
                <template #buttons="{ submit, cancel }">
                    <div class="d-flex justify-content-between">
                        <st-button
                            size="large"
                            variant="link"
                            :callback="cancel"
                            :disabled="loading"
                        >
                            {{ $t('GENERAL.BUTTON.CANCEL') }}
                        </st-button>
                        <st-button
                            size="large"
                            :callback="submit"
                            :spinner="loading"
                        >
                            {{ $t('GENERAL.BUTTON.ADD') }}
                        </st-button>
                    </div>
                </template>
            </tax-category-form>
        </template>
    </st-modal>
</template>

<script>
import TaxCategoryForm from './TaxCategoryForm.vue';

export default {
    name: 'AddTaxCategoryModal',
    components: {
        TaxCategoryForm,
    },
    props: {
        loading: {
            type: Boolean,
        },
    },
    methods: {
        show() {
            this.$refs['st-add-tax-category-modal'].show();
        },
        hide() {
            this.$refs['st-add-tax-category-modal'].hide();
        },
        submit(item) {
            this.$emit('submit', item);
        },
    },
}
</script>